import { cn } from "@/lib/utils"

interface StickyActionBarProps {
  children: React.ReactNode
  className?: string
  /** Si true se muestra también en desktop. Default: solo mobile */
  alwaysVisible?: boolean
}

/**
 * Barra inferior sticky para acciones primarias en formularios largos.
 * Mobile: aparece sobre el BottomNav (z-40, levantado por safe-area).
 * Desktop: oculta por defecto (acciones inline en PageHeader).
 */
export default function StickyActionBar({
  children,
  className,
  alwaysVisible = false,
}: StickyActionBarProps) {
  return (
    <>
      <div
        className={cn(
          "fixed inset-x-0 z-40 border-t border-line bg-card/95 backdrop-blur-md shadow-bottom-bar pb-safe",
          // Mobile: justo arriba del BottomNav (que mide ~56px + safe)
          "bottom-[calc(56px+env(safe-area-inset-bottom))]",
          alwaysVisible
            ? "md:bottom-0"
            : "md:hidden",
          className
        )}
      >
        <div className="px-4 py-3 flex items-center gap-2 md:max-w-3xl md:mx-auto">
          {children}
        </div>
      </div>
      {/* Spacer para que el contenido no quede tapado */}
      <div
        aria-hidden="true"
        className={cn("h-20", alwaysVisible ? "" : "md:hidden")}
      />
    </>
  )
}
